//
//
//		Braintree v3 Helper File
// 			- the new braintree, is more verbose in its implmentation, with  double the code to do the same thing
//			- the added better handling of braintree errors and force us to handle the click events
//			- so i abstracted it into this file to make it easeier to just replicate it around the site
//
//

import btClient from 'braintree-web/client';
import btPaypal from 'braintree-web/paypal';
import btHostedFields from 'braintree-web/hosted-fields';


export let paypalObj = null;
export let hostedFieldsObj = null;
export let dataCollectorObj = null;
// Step 1a
export function setupHostedFields( container, font, button, submitFunction, failFunction){
	button = document.querySelector( "#" + button);
	hostedFieldsObj = { container,button, font, submitFunction, failFunction };
}

// Step 1b
export function setupPaypal( button, submitFunction, failFunction){
	button = document.querySelector( "#" + button);
	paypalObj = { button,  submitFunction, failFunction };
}

// Step 2
export function braintreeObjCreate(token){
	btClient.create({ authorization: token },
		function(clientErr, instance) {
	   if (clientErr) return console.error(clientErr);
	   else {
   		createHostedFieldInstance(instance);
   		createPaypalInstance(instance);
	   }
	 });
}

function createPaypalInstance(clientInstance){
	if( !paypalObj ) return; //need the values set up before we create inst
	btPaypal.create({ client: clientInstance },
		function (createErr, instance) {
	    if (createErr) {
	      if (createErr.code === 'PAYPAL_BROWSER_NOT_SUPPORTED')
	        console.error('This browser is not supported.');
	      else
	        console.error('Error!', createErr);
	    } else {
	    	paypalObj.instance = instance;
			  paypalObj.button.addEventListener('click', function () {
			  // Disable the button so that we don't attempt to open multiple popups.
			  paypalObj.button.setAttribute('disabled', 'disabled');
			  // Because PayPal tokenization opens a popup, this must be called
			  // as a result of a user action, such as a button click.
		    paypalObj.instance.tokenize({ flow: 'vault' },
		    	function (tokenizeErr, payload) {
		      	paypalObj.button.removeAttribute('disabled');
			      if (tokenizeErr) {
			        // Handle tokenization errors or premature flow closure
			        switch (tokenizeErr.code) {
			          case 'PAYPAL_POPUP_CLOSED':
			            console.error('Customer closed PayPal popup.');
			            break;
			          case 'PAYPAL_ACCOUNT_TOKENIZATION_FAILED':
			            console.error('PayPal tokenization failed. See details:', tokenizeErr.details);
			            break;
			          case 'PAYPAL_FLOW_FAILED':
			            console.error('Unable to initialize PayPal flow. Are your options correct?', tokenizeErr.details);
			            break;
			          default:
			            console.error('Error!', tokenizeErr);
			        }
			        paypalObj.failFunction(tokenizeErr);
			      } else
			        paypalObj.submitFunction(payload);
		    	});
		  	});
			}
		});
}


function createHostedFieldInstance(clientInstance){
	if( !hostedFieldsObj ) return; //need the values set up before we create inst
  btHostedFields.create({
    client: clientInstance,
    styles: {
		  'input': {
		    'color': '#000',
		    'font-size': '12pt',
		    'font-family': hostedFieldsObj.font,
		    '-webkit-transition': 'color 100ms ease-out',
		    'transition': 'color 100ms ease-out'
		  },
		  'input:focus': { 'color': '#333' },
		  'input.invalid': { 'color': 'tomato' },
		  'input.valid': { 'color': 'limegreen' }
		},
    fields: {
      number: { selector: "#" + hostedFieldsObj.container + " #card-number" },
      expirationDate: { selector: "#" + hostedFieldsObj.container + "  #expiration-date" },
      cvv: { selector: "#" + hostedFieldsObj.container + " #cvv" },
      postalCode: { selector: "#" + hostedFieldsObj.container + " #postalCode" },
    }
  }, function(err, instance) {
    if (err) return console.error(err);
    else {
    	hostedFieldsObj.instance = instance;
    	hostedFieldsObj.button.removeAttribute('disabled');
    	hostedFieldsObj.button.addEventListener('click', function(event) {
        event.preventDefault();
        hostedFieldsObj.instance.tokenize(function(tokenizeErr, payload) {
          if (tokenizeErr){
          	hostedFieldsObj.failFunction(tokenizeErr);
          } else
          	hostedFieldsObj.submitFunction(payload);
        });
      }, false);
    }
   });
}


export function braintreeObjDestroy(){
	// if exists we destroy
	console.log("braintree destroy!!");
	if( hostedFieldsObj && hostedFieldsObj.instance )
		hostedFieldsObj.instance.teardown(function (teardownErr) {
		  if (teardownErr) console.error('Could not tear down Hosted Fields!');
		  else hostedFieldsObj = null;
		});
	if( paypalObj && paypalObj.instance )
		paypalObj.instance.teardown(function (teardownErr) {
		  if (teardownErr) console.error('Could not tear down Paypal!');
		  else paypalObj = null;
		});
}


// WEBPACK FOOTER //
// ./src/shared/braintreeClientHelper.js